import { Button, useWindowWidth } from '@prishapolicy/shared/ui'
import React from 'react'
import illustration from './illustration.png'
import Image from 'next/image'
import { RemixiconReactIconComponentType } from 'remixicon-react'
import CustomerService2FillIcon from 'remixicon-react/CustomerService2FillIcon';
import BarChart2FillIcon from 'remixicon-react/BarChart2FillIcon';
import FileWarningFillIcon from 'remixicon-react/FileWarningFillIcon';
import UmbrellaFillIcon from 'remixicon-react/UmbrellaFillIcon';
import GuideFillIcon from 'remixicon-react/GuideFillIcon';
import { useRouter } from 'next/navigation'

export const WhyChoosePrisha = () => {
    const navigate = useRouter();
    const { isXl } = useWindowWidth();
    return (
        <div className={` pb-15 ${!isXl ? ' container' : 'px-5 sm:px-15'}`}>
            <div className='bg-primary rounded-[30px]'>
                <div className='p-8 xl:p-[50px] gap-8 xl:gap-14 grid grid-cols-1 xl:grid-cols-2'>
                    <div className='flex flex-col gap-[30px]'>
                        <div className='flex flex-col'>
                            <h1 className='text-title-2 font-bold text-secondary'>Why choose PrishaPolicy</h1>
                            <p className='font-normal text-body-1 text-white xl:w-[480px]'>6 Reason why we you should chose us to be your policy issuing partner of choice. Allow us to tell you why we are one of the fastest growing insurance brokers</p>
                        </div>
                        <Button text='Know more about us' className='text-white border border-white w-[200px]' onClick={() => navigate.push("/about/who-we-are/")} />
                        <Image src={illustration} alt='' width={480} height={460} />
                    </div>
                    <div className='flex flex-col gap-[18px]'>
                        {WhyChooseCardsData.map((e, idx) =>
                            <WhyChooseCards title={e.title} description={e.description} icon={e.icon} key={idx} />
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

interface WhyChooseCardsProps {
    title: string;
    description: string;
    icon: RemixiconReactIconComponentType
}

export const WhyChooseCardsData: WhyChooseCardsProps[] = [
    {
        icon: CustomerService2FillIcon,
        title: "Customer-Centric Culture",
        description: "For us, you always come first. Our products and services are designed to find the best coverage for all."
    },
    {
        icon: BarChart2FillIcon,
        title: "A Decade of Market Leadership",
        description: "Our teams expertise and experience makes them the perfect guides in choosing a policy that fits your needs."
    },
    {
        icon: UmbrellaFillIcon,
        title: "Reliable and Consistent",
        description: "Rest assured that everything will be taken care of without a glitch. From shortlisting to claims processing & delivering promises without a hitch."
    },
    {
        icon: GuideFillIcon,
        title: "Guided Policy Assistance",
        description: "Our experts are always ready to assist you through every policy detail and process with a fine-tooth comb."
    },
    {
        icon: FileWarningFillIcon,
        title: "Claims Assistance",
        description: "Our DNA prompts - Sales is incomplete without timely support. From start to end, we facilitate smooth processing from lodging to settlement."
    }
]

export const WhyChooseCards = ({ title, description, icon }: WhyChooseCardsProps) => {
    const Icon = icon as RemixiconReactIconComponentType;
    return (
        <div className=' border rounded-lg border-grey-100 border-opacity-25 p-6 w-full'>
            <div className='flex flex-col md:flex-row gap-6 items-start md:items-center w-full '>
                <div className='flex items-center justify-center'>
                    <Icon className='w-10 h-10 text-white font-bold ' />
                </div>
                <div className='flex flex-col gap-2'>
                    <h1 className='text-title-6 font-bold text-secondary'>{title}</h1>
                    <p className='text-white font-normal'>{description}</p>
                </div>
            </div>
        </div>
    )
}
